import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <>
      <div className="main-content">
        <div className="logo-container">
          <div className="orbital-ring orbital-ring-back"></div>
          <h1 className="logo">REDA LABS</h1>
          <div className="orbital-ring orbital-ring-front"></div>
          <div className="orbit-dot"></div>
        </div>
      </div>

      <footer className="footer">
        <nav className="footer-nav">
          <Link to="/">Home</Link>
          <span className="separator">|</span>
          <Link to="/terms">Terms of Service</Link>
          <span className="separator">|</span>
          <Link to="/privacy">Privacy Policy</Link>
          <span className="separator">|</span>
          <Link to="/support">Support</Link>
        </nav>
        <p className="copyright">© 2025 Reda Labs, LLC</p>
      </footer>
    </>
  );
}

export default Home;
